import { render, staticRenderFns } from "./MythOrFact.vue?vue&type=template&id=7b6a85e0"
import script from "./MythOrFact.vue?vue&type=script&lang=js"
export * from "./MythOrFact.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports